import React from "react";
import SimpleReactValidator from "simple-react-validator";
import Contact from "../../ThemeComponents/Contact";
import { withRouter } from "react-router-dom";

class AddEditAddressForm extends React.Component {
    constructor(props) {
        super(props);
        this.valitdatorList = new SimpleReactValidator();
        this.state = {
            ...this.props.contactProp,
            contactObject: this.props.contactObject,
            submitted: false,
            formType: this.props.formTypePro || "",
            checked: false
        };
        this.handleSubmitForm = this.handleSubmitForm.bind(this);
    }

    componentDidMount() {
        if (this.props.contactProp.create_user !== undefined) {
            this.setState({
                checked: this.props.contactProp.create_user
            });
        }
    }

    handleChange = () => {
        this.setState({
            checked: !this.state.checked
        });
    };

    handleSubmitForm(e) {
        e.preventDefault();
        this.setState(
            {
                submitted: true
            },
            function () {
                this.props.handleFormSubmitProp({ ...this.state.contactObject, create_user: this.state.checked });
            }
        );
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.checked !== prevState.checked) {
            this.props.returnState({
                create_user: this.state.checked
            });
        }
    }

    componentWillUnmount() {
        this.props.resetAfterUnmount();
    }


    render() {
        return (
            <form onSubmit={this.handleSubmitForm}>
                <div className="flexElem addCustomer">
                    <Contact
                        contactTypesProp={this.props.contactTypesProp}
                        formTypePro={this.state.formType}
                        contactProp={this.props.contactProp}
                        contactObject={this.props.contactObject}
                        htmlElement={"customer"}
                        shippingAddress={false}
                        requiredField={{
                            first_name: "required",
                            last_name: "required",
                            email: ["email", "required"]
                        }}
                        getChildState={this.getChildState}
                        returnState={this.props.returnState}
                        validatorInstance={this.props.validatorProp}
                    />
                    <div className="mt-md fieldWithIcon"></div>
                </div>


                <div className="row">
                    <div className="col-md-12 mb-xlg">
                        <div className="mt-xlg text-center">
                            <input
                                type="submit"
                                value="Submit"
                                className="customBtn btnBlue"
                            />
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default withRouter(AddEditAddressForm);



// WEBPACK FOOTER //
// ./src/components/Admin/Contacts/AddEditContactForm.jsx